/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('DOMContentLoaded', function() {
  // Free gift product redirect - redirect to homepage if product has 'free-gift' tag
  (function() {
    if (document.body.classList.contains('template-product')) {
      var productJson = document.querySelector('[data-product-json]');
      if (productJson) {
        try {
          var product = JSON.parse(productJson.textContent);
          if (product.tags && product.tags.includes('free-gift')) {
            console.log('TEST:: Free gift product detected, redirecting to homepage');
            window.location.replace('/');
          }
        } catch (e) {
          console.log('TEST:: Error parsing product JSON', e);
        }
      }
    }
  })();

  const checkInstaTitle = setInterval(() => {
    const instaTitle = document.querySelector('#insta-feed h2');
    if (instaTitle) {
      console.log("TEST:: instaTitle", instaTitle);
      const instaLink = document.createElement('a');
      instaLink.href = 'https://www.instagram.com/retoldaromatics/';
      instaLink.style.color = 'black';
      const titleText = instaTitle.innerHTML;
      console.log("TEST:: titleText", titleText);
      instaLink.appendChild(instaTitle);
      // instaTitle.innerHTML = titleText;
      document.getElementById('insta-feed').prepend(instaLink);
      clearInterval(checkInstaTitle);
    }
  }, 500);
});
